import React from "react";
import styled from "@emotion/styled";
import { Container } from "@mui/material";

export default function RichTextRich({ theme, ...props }) {
  const regex = /<a (.+)>(.+)<\/a>/gm;
  const str = props.Copy;
  const subst = `<Button $1>$2</Button>`;
  const result = props.Copy.replace(regex, subst);

  return <Wrapper theme={theme} dangerouslySetInnerHTML={{ __html: result }}></Wrapper>;
}
const Wrapper = styled(Container)``;
